import React, { useState } from "react";
import Navbar from "./Navbar"; // Adjust the path as needed
import SideBar from "./SideBar"; // Adjust the path as needed

const DashboardLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900 text-xs">
      <SideBar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className={`flex-1 flex flex-col transition-all duration-300`}>
        <Navbar />
        <main className="bg-white flex-1 p-2 overflow-auto"> {/* Reduce padding further */}
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;